import CreativeCardContainer from "../../../Components/BonusUi/CreativeCard/CreativeCardContainer";

const CreativeCard = () => {
  return <CreativeCardContainer />;
};

export default CreativeCard;
